import { IAppState } from "./State";

export enum AppAction {
    AirCheckinInfo = 1,
    AirCheckinRequest,
    AirCheckinSelectedTravelers,
    Airports,
    AirportTransfers,
    AncillaryAvailabilityRequest,
    AncillaryAvailabilityResponse,
    AncillaryPricingResponse,
    AvailabilityRequest,
    AvailabilityResponse,
    AvailabilityPaxTypeQuantity,
    Banners,
    BookingProvider,
    BookingTransactionTimeout,
    CheckPrice,
    CmsAncillaries,
    Contacts,
    CountriesData,
    ContactRefNumber,
    ContactAddresses,
    CreateRealPoint,
    CurrentStep,
    Errors,
    FooterMode,
    Fleets,
    FeedBack,
    Genders,
    headerStyle,
    InactiveSearchPanel,
    Languages,
    Locale,
    ManageSeat,
    MissedAncillaries,
    ModificationPricingRequest,
    ModificationPricingResponse,
    NewRoute,
    Passengers,
    PesonList,
    PnrInfo,
    PriceRequest,
    PriceResponse,
    RangeOptions,
    Recaptcha,
    RefreshTokenError,
    RouteOptions,
    Routes,
    SearchMode,
    SeatMap,
    SelectedFlights,
    SelectedAncillaries,
    SetWidth,
    Preloader,
    ShowHeaderSkeleton,
    ShowRetryButton,
    ShowBackButton,
    TransactionTimeout,
    Toasts,
    User,
    ValidationErrors,
}

export interface IAppAction {
    type: AppAction;
    payload: Partial<IAppState>;
}